import mainProgram from '@/api/main-program'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return mainProgram.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return mainProgram.store(data)
  },

  async find(context, id) {
    return await mainProgram.find(id)
  },

  update(context, data) {
    return mainProgram.update(data)
  },

  delete(context, data) {
    return mainProgram.destroy(data)
  }
}
